var Backbone = require('backbone');


var EntityModel = Backbone.Model.extend({
    defaults: {
        id: 0,
        name: ''
    },

    urlRoot: '/api/dbo'
});


module.exports = EntityModel;


//////////////////
// WEBPACK FOOTER
// ./app/models/entity-model.js
// module id = 228
// module chunks = 0